import { render, staticRenderFns } from "./TheLoginPassword.vue?vue&type=template&id=48c55efe&"
import script from "./TheLoginPassword.vue?vue&type=script&lang=js&"
export * from "./TheLoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./TheLoginPassword.vue?vue&type=style&index=0&id=48c55efe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports